import $ from 'jquery';
import DoubleSubmitControlManagerClass from './parts/common/DoubleSubmitControlManagerClass';
import InputValidationManagerClass from './parts/common/InputValidationManagerClass';
import ParentPageBaseClass from './parts/common/ParentPageBaseClass';

/**
 * お客様情報入力：ログイン PC・SP共通クラス
 */
class PageLoginClass extends ParentPageBaseClass {
  constructor() {
    super();
    this.name = 'PageLoginClass';
    this.onKeydownListener = this.onKeyDown.bind(this);
  }

  onCreate() {
    this.things.validation = new InputValidationManagerClass($('#main .login.section form'), $('#main .login.section .css_button'));
    // ログイン 画面で、submit_errorメッセージを削除しない
    this.things.validation.errorClearFlg = false;
    this.things.doubleSubmitCtrl = new DoubleSubmitControlManagerClass();
    this.form = $('#main form');
    this.form.prevObject.on("keydown",this.onKeydownListener);
    super.onCreate();
  }

  onKeyDown(event) {
    var keyCode = event.keyCode || event.which;
    if(keyCode == "13"){
      $('[data-submit-ctrl]').each((index, element) => {
        const buttonId = $(element).attr('data-submit-ctrl');
        if (buttonId === "0"){
          element.click();
        }
      });
    }
  }
}
export const pageCl = new PageLoginClass();
